import { __module as o } from "./chunk665.js";
import { __require as B } from "./chunk447.js";
var K = o.exports, f;
function q() {
  return f ? o.exports : (f = 1, function(u, z) {
    (function(n, i) {
      u.exports = i(B());
    })(K, function(n) {
      (function() {
        var i = n, v = i.lib, _ = v.Base, l = i.enc, p = l.Utf8, m = i.algo;
        m.HMAC = _.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(e, r) {
            e = this._hasher = new e.init(), typeof r == "string" && (r = p.parse(r));
            var t = e.blockSize, a = t * 4;
            r.sigBytes > a && (r = e.finalize(r)), r.clamp();
            for (var c = this._oKey = r.clone(), h = this._iKey = r.clone(), d = c.words, x = h.words, s = 0; s < t; s++)
              d[s] ^= 1549556828, x[s] ^= 909522486;
            c.sigBytes = h.sigBytes = a, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var e = this._hasher;
            e.reset(), e.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(e) {
            return this._hasher.update(e), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(e) {
            var r = this._hasher, t = r.finalize(e);
            r.reset();
            var a = r.finalize(this._oKey.clone().concat(t));
            return a;
          }
        });
      })();
    });
  }(o), o.exports);
}
export {
  q as __require
};
